import { LeaderboardPart } from "model/Leaderboard/User/SegmentLeaderboardUser";
import { Pick } from "model/Pickem/Pickem";
import { PointsPartition } from "model/PickemDetails/PointsPartition";
import { RankemDetails } from "model/PickemDetails/Rankem/Details";
import { selectPickemMatchIdsFromBracket } from "selectors/PickemDetails";
import { PickemUserRankemTable } from "./PickemUserRankemTable";
import { Bracket } from "model/Tournament/Segment/Bracket/Bracket";
import { onlyUnique } from "Utility";
import { selectMatchesRosterIds } from "selectors/Match";
import { useAppSelector } from "app/hooks";

interface Props {
  rankemDetails: RankemDetails;
  picks: {
    [id: string]: Pick;
  };
  bracket: Bracket;
  leaderboardPart: LeaderboardPart | undefined;
  columns: PointsPartition[];
}

export const PickemUserRankemBracketPicks = ({
  rankemDetails,
  picks,
  columns,
  bracket,
  leaderboardPart,
}: Props) => {
  const matchIds = useAppSelector((state) =>
    selectPickemMatchIdsFromBracket(state, bracket, rankemDetails)
  );

  const matchRosterIds = useAppSelector((state) =>
    selectMatchesRosterIds(state, matchIds)
  );

  const rosterIds = [
    ...matchRosterIds,
    ...(rankemDetails.additionalRosterIds ?? []),
  ].filter(onlyUnique);

  return (
    <PickemUserRankemTable
      picks={picks}
      leaderboardPart={leaderboardPart}
      columns={columns}
      groupRosterIds={rosterIds}
      tournamentId={rankemDetails.tournamentId}
      name={bracket.name}
    />
  );
};
